"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseBodySection = void 0;
var _PrettyJson = require("./PrettyJson");
var _UnformattedBlock = require("./UnformattedBlock");
var _jsxRuntime = require("react/jsx-runtime");
const ResponseBodySection = ({
  responseBody
}) => {
  if (responseBody === undefined || responseBody === null) {
    return null;
  }

  // If responseBody is a string, parse it as JSON
  if (typeof responseBody === 'string') {
    try {
      const formattedResponseBody = JSON.stringify(JSON.parse(responseBody), null, 2);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PrettyJson.PrettyJson, {
        value: formattedResponseBody
      });
    } catch {
      // Just use the unformatted string if parsing fails
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_UnformattedBlock.UnformattedBlock, {
      children: responseBody
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_UnformattedBlock.UnformattedBlock, {
    children: JSON.stringify(responseBody, null, 2)
  });
};
exports.ResponseBodySection = ResponseBodySection;
